
    <h1 mat-dialog-title>Enter New Scope</h1>
    <div mat-dialog-content>
      <form [formGroup]="scopeForm">
        <mat-form-field style="width:100%">
          <mat-label>New Scope</mat-label>
          <input matInput placeholder="Enter scope name" formControlName="scopeName" />
          <mat-error *ngIf="scopeForm.get('scopeName').invalid">Scope name is required</mat-error>
        </mat-form-field>


        
      <!-- Category is REQUIRED: it drives the Multi-family scope filter on the
           subdivision dialog, so a scope saved without one could never be found
           by that filter. Same layout as the Description field below it. -->
      <mat-form-field style="width:100%; margin-top: 2em;">
        <mat-label>Category</mat-label>
        <mat-select formControlName="scopeCategory">
          <mat-option *ngFor="let c of categories" [value]="c">{{c}}</mat-option>
        </mat-select>
        <mat-error *ngIf="scopeForm.get('scopeCategory').invalid">Category is required</mat-error>
      </mat-form-field>

      <mat-form-field style="width:100%; margin-top: 2em;">
        <mat-label>Description (Optional)</mat-label>
        <textarea matInput placeholder="Enter scope name (optional)" formControlName="scopeDesc"></textarea>
      </mat-form-field>

      </form>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-button [disabled]="scopeForm.invalid" (click)="onConfirm()">Confirm</button>
    </div>
  